import React from "react";
import styled from "styled-components";
import img from "../assets/images/homepage/aboutimg.svg";

const About = () => {
  return (
    <AboutContainer id="about">
      <AboutContainerLeft>
        <AboutImg src={img} />
      </AboutContainerLeft>
      <AboutContainerRight>
        <AboutHeading>OUR COMPANY</AboutHeading>
        <AboutSubHeading>A Few Words</AboutSubHeading>
        <AboutSubHeading> About Us</AboutSubHeading>
        <AboutDesc>
        Senior Care Pharmacy has developed into an all out medical care supplier. While proceeding to give an elevated degree of items and administrations, we have made a tremendous organization of fulfilled clients. Throughout the long term, we have extended the administrations we offer while keeping up with a similar elevated degree of client support we have consistently given. Our administrations currently incorporate long haul care, helped living, remedy compounding, and clinical gear deals notwithstanding the conventional retail drug store administrations.
        </AboutDesc>
      </AboutContainerRight>
    </AboutContainer>
  );
};

export default About;

const AboutDesc = styled.p`
  color: var(--color-blue);
  text-align: justify;
  opacity: 0.6;
  letter-spacing: 1px;
  font-size: 1.1rem;
`;

const AboutContainerRight = styled.div`
display: flex;
flex-direction: column;
gap: 1rem;
`;

const AboutImg = styled.img`
  width: 90%;
`;

const AboutContainerLeft = styled.div`
display: flex;
align-items: center;
justify-items: center;
`;

const AboutContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: 1100px;
  margin: auto;
  gap: 2rem;
  margin-top: 2rem;
  margin-bottom: 8rem;
`;

const AboutSubHeading = styled.h1`
  color: var(--color-blue);
  font-weight: bolder;
  letter-spacing: 2px;
  font-size: 2.5rem;
  line-height: 3rem;
`;

const AboutHeading = styled.h4`
  color: var(--color-red);
  font-weight: bolder;
  letter-spacing: 2px;
`;
